import {Component, createRef} from 'react';
import PropTypes from 'prop-types';

import {Animated, Text, View, ViewPropTypes} from 'react-native';
import React from "react";

let container = null;

export default class BaseInput extends Component {
    static propTypes = {
        label: PropTypes.string,
        value: PropTypes.string,
        defaultValue: PropTypes.string,
        style: ViewPropTypes ? ViewPropTypes.style : View.propTypes.style,
        inputStyle: Text.propTypes.style,
        labelStyle: Text.propTypes.style,
        easing: PropTypes.func,
        animationDuration: PropTypes.number,
        useNativeDriver: PropTypes.bool,

        editable: PropTypes.bool,

        /* those are TextInput props which are overridden
         * so, i'm calling them manually
         */
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
        onChange: PropTypes.func,
    };

    constructor(props, context) {
        super(props, context);

        container = this;
        //  this[`input${props.refName}`] = createRef();
        container.input = createRef();

        this._onLayout = this._onLayout.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onBlur = this._onBlur.bind(this);
        this._onFocus = this._onFocus.bind(this);
        //  this._onSubmitEditing = this._onSubmitEditing.bind(this);
        this.focus = this.focus.bind(this);

        // const value = props.value || props.defaultValue;
        const value = props.value;

        let checkValue = (value === null || value === "null" || value === undefined || value === "undefined" || value === "");
        this.state = {
            value,
            focusedAnim: new Animated.Value(checkValue ? 0 : 1),
            width: null,
        };
        // if (checkValue)
        //     this._toggle(true);


    }

    componentWillReceiveProps(newProps) {
        const newValue = newProps.value;

        if (newProps.hasOwnProperty('value') && newValue !== this.state.value) {
            let checkValue = (newValue === null || newValue === "null" || newValue === undefined || newValue === "undefined" || newValue === "");

            this.setState({
                focusedAnim: new Animated.Value(checkValue ? 0 : 1),
                value: newValue,
            });

            // animate input if it's active state has changed with the new value
            // and input is not focused currently.
            // const isFocused = this.inputRef().isFocused();
            /*    const isFocused = this.props.refName.isFocused();
                if (!isFocused) {
                  const isActive = Boolean(newValue);
                  if (isActive !== this.isActive) {
                    this._toggle(isActive);
                  }
                }*/
        }
    }

    _onLayout(event) {
        this.setState({
            width: event.nativeEvent.layout.width,
        });
    }

    _onChange(event) {

        if (this.props.lengthWord) {
            if (event.nativeEvent.text.length <= 3)
                this.setState({
                    value: event.nativeEvent.text,
                });
        }
        else {
            let text = event.nativeEvent.text;
            this.setState({
                value: (text === null || text === "null" || text === undefined || text === "undefined" || text === "") ? null : event.nativeEvent.text,
                //  value: event.nativeEvent.text,
            });
        }


        const onChange = this.props.onChange;
        if (onChange) {
            onChange(event);
        }
    }

    _onBlur(event) {
        if (!this.state.value) {
            this._toggle(false);
        }

        const onBlur = this.props.onBlur;
        // const onBlur = this.props.onBlur;

        if (onBlur) {
            //  console.log("onBlur v", event.target.value, this.props)

            onBlur(event, this.props.refName);
        }
    }

    _onFocus(event) {
        /*        var temp_value = event.target.value
                event.target.value = ''
                event.target.value = temp_value*/


        this._toggle(true);

        const onFocus = this.props.onFocus;

        if (onFocus) {

            onFocus(event);
        }
    }

    /*  _onSubmitEditing(name) {
         // this.props.onSubmitEditing(this[`inputLastName`].current)

      }*/

    _toggle(isActive) {
        const {animationDuration, easing, useNativeDriver} = this.props;
        this.isActive = isActive;
        Animated.timing(this.state.focusedAnim, {
            toValue: isActive ? 1 : 0,
            duration: animationDuration,
            easing,
            useNativeDriver,
        }).start();
    }

    // public methods


    inputRef() {
        //  return this[`input${this.props.refName}`].current;
        //return this.props.refName
        return this.input.current;

    }

    focus() {
        //alert(this.inputRef())
        // if (this.props.editable !== false) {
        // alert(this.inputRef())
        if (this.inputRef())
            this.inputRef().focus();
        //  }
    }

    blur() {
        this.inputRef().blur();
    }

    isFocused() {
        return this.inputRef().isFocused();
    }

    clear() {
        this.inputRef().clear();
    }
}
